import { useSelector } from "react-redux";
import { selectPersonas } from "../../redux/features/agent/agentSlice";
import "./DeterminedPersonas.css";

type DeterminedPersonasProps = {
  personaIds: string[];
};

export const DeterminedPersonas = ({ personaIds }: DeterminedPersonasProps) => {
  const personas = useSelector(selectPersonas);

  if (!personaIds || personaIds.length === 0) return null;

  return (
    <div className="agent-chat-history-item-determined-personas">
      {personaIds.map((personaId) => {
        const persona = personas.find((p) => p.id === personaId);
        return (
          <div className="determined-persona" key={personaId}>
            <div className="determined-persona-name">{persona?.name}</div>
          </div>
        );
      })}
    </div>
  );
};
